import React from "react";
import TextField, { type TextFieldProps } from "./TextField";

export type TextAreaProps = TextFieldProps;

const TextArea = React.forwardRef(
  (
    { rows = 5, ...rest }: TextFieldProps,
    ref: React.Ref<HTMLTextAreaElement>,
  ): React.ReactElement => (
    <TextField multiline fullWidth ref={ref} {...rest} rows={rows} />
  ),
);

export default TextArea;
